"use client";
import { IScrollableTabsCategory } from "@/api/AppApi/services/home/interfaces/IScrollableTabs";
import { useEffect, useState } from "react";
import ProductTabsCarousel from "./ProductTabsCarousel";
import { scrollSpy } from "react-scroll";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useIsMobile } from "@/hooks/useIsMobile";
import useIsClient from "@/hooks/useIsClient";

interface Props {
  data: IScrollableTabsCategory[];
  viewIcons: boolean;
}
const ProductTabsClient: React.FC<Props> = ({ data, viewIcons }) => {
  const client = useIsClient();
  const getCompany = useGetCompanyQuery();
  const { show_receiving_header } = getCompany?.data?.result ?? {};
  const isMobile = useIsMobile();
  const mainHeaderTop = isMobile ? 106 : 64;
  const deliveryHeaderTop = isMobile ? 82 : 38;
  const top = show_receiving_header
    ? mainHeaderTop + deliveryHeaderTop
    : mainHeaderTop;
  const [activeTab, setActiveTab] = useState(0);
  const tabs = data.map((p) => {
    return { id: p.id, name: p.name, icon_src: p.icon };
  });
  useEffect(() => {
    scrollSpy.update();
  }, []);
  if (!client) return;
  return (
    <>
      <div
        className="pop-up-scrollabll-tabs-container"
        style={{ top, boxSizing: "border-box" }}
      >
        <ProductTabsCarousel
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={tabs}
          viewIcons={viewIcons}
        />
      </div>
    </>
  );
};

export default ProductTabsClient;
